import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {CampoData, CampoSelect, CampoTexto} from '../../components/processo/CamposProcesso.jsx';
import {NOMES_DO_PROGRAMA, SEMESTRES} from '../../components/processo/processoSelecao.js';
import {TAMANHO_MAXIMO_DESCRICAO} from '../../components/processo/processoSelecaoSchema.js';

const OPCOES_NOME_PROGRAMA = NOMES_DO_PROGRAMA.map(nome => ({valor: nome, descricao: nome}));

/*
 * Aba "Geral": programa ofertado (travado na edição), descrição, link para a
 * documentação, edital, ano/semestre de referência, nome do programa e data
 * do edital.
 */
export default function TabGeral({control, errors, programas = [], edicao = false, onTrocarPrograma}) {
    const props = {control, errors};
    return (
        <Grid container spacing={3}>
            <CampoSelect {...props} nome='idPrograma' rotulo='Programa ofertado *' disabled={edicao} onAlterar={onTrocarPrograma}
                         opcoes={programas.map(programa => ({valor: String(programa.id), descricao: programa.descricao}))}/>
            <CampoTexto {...props} nome='descricao' rotulo='Descrição *' maxLength={TAMANHO_MAXIMO_DESCRICAO}/>
            <CampoTexto {...props} nome='link' rotulo='Link para documentação' sm={12} multiline/>
            <CampoTexto {...props} nome='numeroEdital' rotulo='Nº do Edital' sm={3} type='number'/>
            <CampoTexto {...props} nome='anoVigente' rotulo='Ano vigente' sm={3} type='number'/>
            <CampoSelect {...props} nome='semestreReferencia' rotulo='Semestre de referência *' sm={3}
                         opcoes={SEMESTRES.map(semestre => ({valor: semestre.valor, descricao: semestre.descricao}))}/>
            <CampoSelect {...props} nome='nomeDoPrograma' rotulo='Nome do programa *' sm={3} opcoes={OPCOES_NOME_PROGRAMA}/>
            <CampoData {...props} nome='dataEdital' rotulo='Data do Edital *' sm={3}/>
        </Grid>
    );
}

TabGeral.propTypes = {
    control: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    programas: PropTypes.array,
    edicao: PropTypes.bool,
    onTrocarPrograma: PropTypes.func
};
